import { ApplicationConfig, importProvidersFrom, provideZonelessChangeDetection } from '@angular/core'
import { provideRouter, withPreloading, PreloadAllModules, Routes } from '@angular/router'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { provideHttpClient, withInterceptors } from '@angular/common/http'
import { OktaAuthModule, OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular'
import OktaAuth from '@okta/okta-auth-js'
import { DATE_PIPE_DEFAULT_OPTIONS, TitleCasePipe } from '@angular/common'
import { authInterceptor } from './interceptors/auth.interceptor'
import { AddressPipe } from './pipes/address.pipe'
import { ServiceDescriptionPipe } from './pipes/service-description.pipe'
import { StatusPipe } from './pipes/status.pipe'
import { EtaPipe } from './pipes/eta.pipe'
import { environment } from '../environments/environment'
import { DATE_FORMAT } from './utils/constants'

const oktaAuth = new OktaAuth({
  ...environment.okta,
})

const routes: Routes = [
  { path: 'login/callback', component: OktaCallbackComponent },
  {
    path: 'create-call',
    loadComponent: () => import('./create-call/create-call.component').then(m => m.CreateCallComponent),
    canActivate: [OktaAuthGuard],
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./dashboard/dashboard.component').then(m => m.DashboardComponent),
    canActivate: [OktaAuthGuard],
  },
]

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor])),
    importProvidersFrom(OktaAuthModule.forRoot({ oktaAuth })),
    AddressPipe,
    ServiceDescriptionPipe,
    TitleCasePipe,
    StatusPipe,
    EtaPipe,
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { dateFormat: DATE_FORMAT } },
  ]
}
